module.exports = __webpack_public_path__ + "static/media/no_route_bg.30ec0922.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_route_bg.jpg
// module id = 1843
// module chunks = 0